import React, { createContext, useContext, useState, type ReactNode } from "react";
import type { Application } from "@features/Admissions/types/types";

interface ApplicationContextType {
	selectedApplication: Application | null;
	setSelectedApplication: (application: Application | null) => void;
}

const ApplicationContext = createContext<ApplicationContextType | undefined>(undefined);

export const useApplicationContext = (): ApplicationContextType => {
	const context = useContext(ApplicationContext);
	if (context === undefined) {
		throw new Error("useApplicationContext must be used within an ApplicationProvider");
	}
	return context;
};

interface ApplicationProviderProps {
	children: ReactNode;
}

export const ApplicationProvider: React.FC<ApplicationProviderProps> = ({ children }) => {
	const [selectedApplication, setSelectedApplication] = useState<Application | null>(null);

	return (
		<ApplicationContext.Provider value={{ selectedApplication, setSelectedApplication }}>
			{children}
		</ApplicationContext.Provider>
	);
};
